export default __webpack_public_path__ + "static/media/App-Showcase-1.3ee4d8c7.png";